/**
 * Translation to finnish cookie button aria-label.
 */
export function cookiesInit() {
	document.addEventListener("DOMContentLoaded", () => {
		// One second timeout to wait that cookieinformation is loaded to page.
		setTimeout( () => {
			const cookiesRenewButton = document.getElementById( 'Coi-Renew' );
			if ( document.documentElement.lang === 'fi' && cookiesRenewButton ) {
				cookiesRenewButton.setAttribute( 'aria-label', 'Evästeasetukset' );
			} else if ( document.documentElement.lang === 'sv-SE' && cookiesRenewButton ) {
				cookiesRenewButton.setAttribute( 'aria-label', 'Cookie-inställningar' );
			}
		}, '1000' );
	});
}